import React, { useEffect, useState } from 'react'
import "../AdminDashboard.css"
import "./AddMember.css"
import axios from "axios"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import { Card, Button, Input, Select } from '../../../../ui'
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import CircularProgress from '@material-ui/core/CircularProgress';
import BookIcon from '@material-ui/icons/Book';

function AddMember() {
    const API_URL = process.env.REACT_APP_API_URL
    const [isLoading, setIsLoading] = useState(false)

    const [userFullName, setUserFullName] = useState("")
    const [admissionId, setAdmissionId] = useState("")
    const [employeeId, setEmployeeId] = useState("")
    const [address, setAddress] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [mobileNumber, setMobileNumber] = useState("")
    const [recentAddedMembers, setRecentAddedMembers] = useState([])
    const [userType, setUserType] = useState("Student")
    const [gender, setGender] = useState("")
    const [age, setAge] = useState("")
    const [dob, setDob] = useState(null)
    const [dobString, setDobString] = useState(null)

    const genderTypes = [
        { value: "Male", text: "Male" },
        { value: "Female", text: "Female" }
    ]

    const userTypes = [
        { value: 'Staff', text: 'Staff' },
        { value: 'Student', text: 'Student' }
    ]

    //Add a Member
    const addMember = async (e) => {
        e.preventDefault()
        setIsLoading(true)
        if (userFullName && userType && age && dobString && gender && address && mobileNumber && email && password) {
            const userData = {
                userType: userType,
                userFullName: userFullName,
                admissionId: admissionId,
                employeeId: employeeId,
                age: age,
                dob: dobString,
                gender: gender,
                address: address,
                mobileNumber: mobileNumber,
                email: email,
                password: password
            }
            try {
                const response = await axios.post(API_URL + "api/auth/register", userData)
                if (recentAddedMembers.length >= 5) {
                    recentAddedMembers.splice(-1)
                }
                setRecentAddedMembers([response.data, ...recentAddedMembers])
                setUserFullName("")
                setUserType("Student")
                setAdmissionId("")
                setEmployeeId("")
                setAddress("")
                setMobileNumber("")
                setEmail("")
                setPassword("")
                setGender("")
                setAge("")
                setDob(null)
                setDobString(null)
                alert("Member Added Successfully 🎉")
            }
            catch (err) {
                console.log(err)
                alert("Failed to add member. Please try again.")
            }
        }
        else {
            alert("All the fields must be filled")
        }
        setIsLoading(false)
    }

    //Fetch Members
    useEffect(() => {
        const getMembers = async () => {
            try {
                const response = await axios.get(API_URL + "api/users/allmembers")
                const recentMembers = await response.data.slice(0, 5)
                setRecentAddedMembers(recentMembers)
            }
            catch (err) {
                console.log(err)
            }
        }
        getMembers()
    }, [API_URL])

    return (
        <div className="addmember-container">
            <h2 className="addmember-title">Add a Member</h2>

            <Card padding="lg" className="addmember-form-card">
                <form className="addmember-form" onSubmit={addMember}>
                    <div className="addmember-form-grid">
                        <Select
                            id="user-type-select"
                            label={
                                <>
                                    User Type<span className="required-field">*</span>
                                </>
                            }
                            placeholder="Select User Type"
                            value={userType}
                            options={userTypes}
                            onChange={(e) => setUserType(e.target.value)}
                        />

                        <Input
                            label="Full Name"
                            type="text"
                            name="userFullName"
                            value={userFullName}
                            required
                            onChange={(e) => setUserFullName(e.target.value)}
                            placeholder="Enter full name"
                        />

                        {userType === "Student" ? (
                            <Input
                                label="Admission ID"
                                type="text"
                                name="admissionId"
                                value={admissionId}
                                required
                                onChange={(e) => setAdmissionId(e.target.value)}
                                placeholder="Enter admission ID"
                            />
                        ) : (
                            <Input
                                label="Employee ID"
                                type="text"
                                name="employeeId"
                                value={employeeId}
                                required
                                onChange={(e) => setEmployeeId(e.target.value)}
                                placeholder="Enter employee ID"
                            />
                        )}

                        <Input
                            label="Mobile Number"
                            type="text"
                            name="mobileNumber"
                            value={mobileNumber}
                            required
                            onChange={(e) => setMobileNumber(e.target.value)}
                            placeholder="Enter mobile number"
                        />

                        <Select
                            id="gender-select"
                            label={
                                <>
                                    Gender<span className="required-field">*</span>
                                </>
                            }
                            placeholder="Select Gender"
                            value={gender}
                            options={genderTypes}
                            onChange={(e) => setGender(e.target.value)}
                        />

                        <Input
                            label="Age"
                            type="number"
                            name="age"
                            value={age}
                            required
                            onChange={(e) => setAge(e.target.value)}
                            placeholder="Enter age"
                        />

                        <div className="addmember-form-group">
                            <label className="addmember-form-label">Date of Birth<span className="required-field">*</span></label>
                            <DatePicker
                                className="addmember-datepicker"
                                placeholderText="MM/DD/YYYY"
                                selected={dob}
                                onChange={(date) => { setDob(date); setDobString(moment(date).format("MM/DD/YYYY")) }}
                                dateFormat="MM/dd/yyyy"
                            />
                        </div>

                        <Input
                            label="Address"
                            type="text"
                            name="address"
                            value={address}
                            required
                            onChange={(e) => setAddress(e.target.value)}
                            placeholder="Enter address"
                        />

                        <Input
                            label="Email"
                            type="email"
                            name="email"
                            value={email}
                            required
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter email"
                        />

                        <Input
                            label="Password"
                            type="password"
                            name="password"
                            value={password}
                            required
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter password"
                        />
                    </div>

                    <Button
                        type="submit"
                        variant="primary"
                        size="lg"
                        disabled={isLoading}
                        leadingIcon={isLoading ? <CircularProgress size={20} /> : <PersonAddIcon />}
                        className="addmember-submit"
                    >
                        {isLoading ? 'Adding...' : 'Add Member'}
                    </Button>
                </form>
            </Card>

            <div className="addmember-recent">
                <h3 className="addmember-section-title">Recently Added Members</h3>
                {recentAddedMembers.length > 0 ? (
                    <Card padding="md" className="addmember-table-card">
                        <div className="addmember-table-wrapper">
                            <table className='addmember-table'>
                                <thead>
                                    <tr>
                                        <th>S.No</th>
                                        <th>Member Type</th>
                                        <th>Member ID</th>
                                        <th>Member Name</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {recentAddedMembers.map((member, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            <td>{member.userType}</td>
                                            <td>{member.userType === "Student" ? member.admissionId : member.employeeId}</td>
                                            <td>{member.userFullName}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </Card>
                ) : (
                    <Card padding="lg" className="addmember-empty-state">
                        <BookIcon style={{ fontSize: 48, marginBottom: 16 }} />
                        <p>No members added yet.</p>
                    </Card>
                )}
            </div>
        </div>
    )
}

export default AddMember
